import React, { useEffect } from "react";
import Select from "react-select";

const CascadingDropdown = ({
  label,
  employeeOptions,
  roomOptions,
  onSelect,
  setFilteredOptions,
  setSelectedItem,
  setSelectedCategory,
  selectedCategory,
  selectedItem,
  filteredOptions,
  milestoneOptions,
}) => {
  useEffect(() => {
    if (selectedCategory === "employee") {
      setFilteredOptions(employeeOptions);
    } else if (selectedCategory === "room") {
      setFilteredOptions(roomOptions);
    } else if (selectedCategory === "milestone") {
      setFilteredOptions(milestoneOptions);
    }
  }, [selectedCategory, employeeOptions, roomOptions, milestoneOptions]);

  const handleCategoryChange = (selectedOption) => {
    setSelectedCategory(selectedOption.value);
    setSelectedItem({ value: "all", label: "All" });
    onSelect("all");
  };

  const handleItemChange = (selectedOption) => {
    if (selectedOption.value === "all") {
      setSelectedItem({ value: "all", label: "All" });
      onSelect("");
    } else {
      let filteredOptions = selectedOption
        ?.filter(option => option.value !== "all") // Exclude "all"
        .map(option => parseInt(option.value));
      setSelectedItem(selectedOption);
      onSelect(`${selectedCategory}_id=${[filteredOptions]}`);
    }
  };

  const enhancedOptions = [
    { value: "all", label: "All" },
    ...filteredOptions.map((option) => ({
      value: option.id,
      label: selectedCategory === "employee" ? option.user_name : selectedCategory === "room" ? option.name : option.name,
    })),
  ];

  return (
    <div className="d-flex flex-nowrap gap-3">
      <Select
        options={[
          { value: "", label: "All" },
          { value: "employee", label: "Employees" },
          { value: "room", label: "Rooms" },
          { value: "milestone", label: "Milestones" },
        ]}
        value={{
          value: selectedCategory,
          label: selectedCategory
            ? selectedCategory === "employee"
              ? "Employees"
              : selectedCategory === "room"
                ? "Rooms"
                : "Milestones"
            : "All",
        }}
        onChange={handleCategoryChange}
        isSearchable={false}
        placeholder="Select Category"
        className="dynamicFilter"
      />

      {selectedCategory && (
        <Select
          options={enhancedOptions}
          value={selectedItem}
          onChange={(e) => {
            handleItemChange(e);
          }}
          isMulti={true}
          placeholder={`Search ${selectedCategory === "employee" ? "Employee" : selectedCategory === "room" ? "Room" : "Milestone"
            }`}
          className="filterDynamic"
        />
      )}
    </div>
  );
};

export default CascadingDropdown;
